export function getId(): string {
  return (
    window.crypto?.randomUUID?.() ||
    Date.now().toString(10) + Math.random().toString()
  );
}
